<div class="main flex flex-col gap-[1.25rem]">
    <!-- Cards -->
    <div class="flex gap-2.5">
      <div class="flex gap-0.625 grow">
        @for (card of analyticsCards; track card.title) {
          <app-bm-analytics-card class="grow" [data]="card"/>
        }
      </div>
    </div>

    <!-- Charts -->
    @if(chartOptions) {
      <div class="flex gap-[1.25rem]">

        <!-- BAR CHART   -->
        <div class="card-border w-[60%] p-0.9375 flex flex-col gap-0.9375">
          <div class="flex gap-0.46875">
            <app-button
              data-qa="bm-analytics-bar-chart-cap-req"
              [type]="selected.barChart === BmBarChartsTypes.capRequired ? 'accent' : 'default'"
              [size]="'xsmall'"
              (buttonClick)="selected.barChart = BmBarChartsTypes.capRequired">
              Required capital
            </app-button>
            <app-button
              data-qa="bm-analytics-bar-chart-inv"
              [type]="selected.barChart === BmBarChartsTypes.investment ? 'accent' : 'default'"
              [size]="'xsmall'"
              (buttonClick)="selected.barChart = BmBarChartsTypes.investment">
              Investment
            </app-button>
            <app-button
              data-qa="bm-analytics-bar-chart-mgm-fee"
              [type]="selected.barChart === BmBarChartsTypes.mgmFee ? 'accent' : 'default'"
              [size]="'xsmall'"
              (buttonClick)="selected.barChart = BmBarChartsTypes.mgmFee">
              Management fees
            </app-button>
            <app-button
              data-qa="bm-analytics-bar-chart-op-exp"
              [type]="selected.barChart === BmBarChartsTypes.opExp ? 'accent' : 'default'"
              [size]="'xsmall'"
              (buttonClick)="selected.barChart = BmBarChartsTypes.opExp">
              Operating expenses
            </app-button>
            <app-button
              data-qa="bm-analytics-bar-chart-org-exp"
              [type]="selected.barChart === BmBarChartsTypes.orgExp ? 'accent' : 'default'"
              [size]="'xsmall'"
              (buttonClick)="selected.barChart = BmBarChartsTypes.orgExp">
              Organizational expenses
            </app-button>
          </div>
          <app-base-bar-chart
            data-qa="bm-analytics-bar-chart"
            [chartId]="chartOptions.bar[selected.barChart].chartId"
            [additionalOptions]="chartOptions.bar[selected.barChart].additionalOptions">
          </app-base-bar-chart>
        </div>

        <!-- PIE CHART   -->
        <div class="card-border w-[39%] p-0.9375 flex flex-col gap-0.9375">
          <span class="font-2 bold600">Commitment allocation</span>
          <app-base-pie-chart
            data-qa="bm-analytics-pie-chart"
            [chartId]="chartOptions.pie.chartId"
            [additionalOptions]="chartOptions.pie.additionalOptions">
          </app-base-pie-chart>
        </div>
      </div>
    }
</div>
